
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionService } from '../../xform-compat';

@Injectable({
  providedIn: 'root'
})
export class PasswordExpiredService {

  private apiUrl = '/api/uaa/authorization/changepassword';

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService
  ) { }

  public resetPassword (body: object) {
    return this.http.post(this.apiUrl, body).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
